<script setup lang="ts">
import { Toaster } from 'vue-sonner';
import { activeModal } from '../ui-modal/stack';
import { resolveModalTeleportTarget } from '../ui-modal/teleportTarget';
import { toastItemClasses, toastViewportClasses } from './classes';
import { IDEO_TOAST_DEFAULT_DURATION } from './duration';

const host = ref<HTMLElement | null>(null);
const teleportTarget = computed(() => activeModal.value ? resolveModalTeleportTarget(activeModal.value) : null);

function showHost()
{
    if (host.value?.isConnected && !host.value.matches(':popover-open'))
        host.value.showPopover();
}

onMounted(showHost);
watch(teleportTarget, async () =>
{
    // Przeniesienie DOM zamyka popover, więc po teleporcie ponownie wynosimy host nad backdrop
    await nextTick();
    showHost();
});
onBeforeUnmount(() =>
{
    if (host.value?.matches(':popover-open'))
        host.value.hidePopover();
});
</script>

<template>
    <Teleport :to="teleportTarget ?? 'body'" :disabled="!teleportTarget">
        <div
            ref="host"
            popover="manual"
            class="pointer-events-none fixed inset-0 m-0 h-full w-full overflow-visible border-0 bg-transparent p-0 text-inherit outline-none backdrop:pointer-events-none backdrop:bg-transparent"
            data-ideo-toaster-host
        >
            <Toaster
                position="top-center"
                :duration="IDEO_TOAST_DEFAULT_DURATION"
                :gap="8"
                :visible-toasts="4"
                :expand="false"
                :offset="16"
                :class="toastViewportClasses"
                :toast-options="{
                    unstyled: true,
                    class: toastItemClasses
                }"
                container-aria-label="Powiadomienia"
                pause-when-page-is-hidden
            />
        </div>
    </Teleport>
</template>
